import moment from 'moment';
import DTO from './DTO';

class DailyTariffDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.id',
      },
      {
        name: 'date',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.date',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.type',
      },
      {
        name: 'vehicle_type',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.vehicle_type',
      },
      {
        name: 'free_duration',
        type: Number,
        validators: {},
        labelKey: 'daily.tariff.free_duration',
      },
      {
        name: 'start_time',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.start_time',
      },
      {
        name: 'end_time',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.end_time',
      },
      {
        name: 'cost',
        type: Number,
        validators: {},
        labelKey: 'daily.tariff.cost',
      },
      {
        name: 'time_unit',
        type: String,
        validators: {},
        labelKey: 'daily.tariff.time_unit',
      },
      {
        name: 'is_active',
        type: Boolean,
        validators: {},
        labelKey: 'daily.tariff.is_active',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: [],
        labelKey: 'updated_at',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default DailyTariffDTO;
